// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@tps/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardExpandedStyles } from "@tps/Overrides/Widgets/Cart/CartLineCardExpanded";
import { fontConfig } from "@tps/XDL/PreStyle/typography";
import { avoidBreakInsidePrintElement, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardExpandedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cartLineCardExpandedStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
    wrapper: {
        css: css`
            ${xScreen("lte", "md")} {
                margin-bottom: 0;
            }
        `,
    },
};

cartLineCardExpandedStyles.extendedUnitNetPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

cartLineCardExpandedStyles.webDiscountMessage = {
    ...cartLineSharedStyles.webDiscountMessage,
    color: "success",
    weight: fontConfig.weight.regular,
};
cartLineCardExpandedStyles.discountValue = {
    ...cartLineSharedStyles.discountValue,
};

cartLineCardExpandedStyles.distributeOrderButton = {
    ...cartLineSharedStyles.distributeOrderButton,
};

cartLineCardExpandedStyles.removeCartLineIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

cartLineCardExpandedStyles.QtyRemoveGridItem = {
    ...cartLineSharedStyles.QtyRemoveGridItem,
};
cartLineCardExpandedStyles.qtyLabel = {
    ...cartLineSharedStyles.qtyLabel,
};
cartLineCardExpandedStyles.totalInnerWrapper = {
    ...cartLineSharedStyles.totalInnerWrapper,
};

cartLineCardExpandedStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

cartLineCardExpandedStyles.configurationOptionText = {
    css: css`
        display: block;
    `,
};

cartLineCardExpandedStyles.deliveryScheduleButton = {
    css: css`
        margin-bottom: 10px;
    `,
};

cartLineCardExpandedStyles.configurationGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};

cartLineCardExpandedStyles.costCodeText = {
    ...cartLineSharedStyles.costCodeValueText,
};

cartLineCardExpandedStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

cartLineCardExpandedStyles.cartLineNotes = {
    ...cartLineSharedStyles.cartLineNotes,
};

cartLineCardExpandedStyles.attributesWrapper = {
    ...cartLineSharedStyles.attributesWrapper,
};
cartLineCardExpandedStyles.variantDisplay = {
    ...cartLineSharedStyles.variantDisplay,
};
cartLineCardExpandedStyles.approximateWeightDisplay = {
    ...cartLineSharedStyles.approximateWeightDisplay,
};
cartLineCardExpandedStyles.cartLineContainerStyles = {
    price: {
        css: css`
            ${xScreen("lte", "md")} {
                margin-bottom: 12px;
            }
        `,
    },
    actions: {
        css: css`
            margin-top: 15px;
            &:empty {
                display: none;
            }
            ${avoidBreakInsidePrintElement}
        `,
    },
};
cartLineCardExpandedStyles.quantity = {
    ...cartLineSharedStyles.quantity,
};
cartLineCardExpandedStyles.branchQtyAvailableHidden = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        row-gap: 4px;
        margin-top: 12px;
        ${xScreen("lte", "md")} {
            margin-top: 8px;
            justify-content: flex-start;
        }
        span {
            line-height: 17px;
        }
    `,
};
cartLineCardExpandedStyles.quantityWrapper = {
    css: css`
        @media print {
            margin-top: 10px;
        }
    `,
};
